import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LockOpenOutlined } from '@mui/icons-material';
import {
  Box,
  Fab,
  FormControl,
  InputLabel,
  Link,
  OutlinedInput,
  Slide,
  Typography
} from '@mui/material';

const cardSx = {
  backgroundColor: '#fff',
  borderRadius: '5px',
  boxShadow: '0px 0px 25px rgba(0, 0, 0, 0.25)',
  display: 'flex',
  flexDirection: 'column',
  mx: 'auto',
  pb: 2.5,
  position: 'relative',
  width: {
    xs: '100%',
    md: '80%'
  }
};

const headerSx = {
  alignItems: 'center',
  background:
    'linear-gradient(90deg, #60CE8C 17.24%, #48BDAF 100%), #2EB256',
  borderRadius: '5px 5px 0 0',
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 160,
  p: 3.75,
  pt: 5,
  width: '100%',

  '& h1': {
    color: '#fff',
    fontWeight: 300,
    textAlign: 'center'
  },

  '& svg': {
    mb: 2.5,
    transform: 'scale(2)'
  }
};

const contentSx = {
  p: 5,
  textAlign: 'center',

  '& h6': {
    fontWeight: 500,
    pb: 1.25
  }
};

const fieldSx = {
  mb: 2,
  maxWidth: 400,
  width: '100%',

  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#E6E9EC'
    },

    '&:hover fieldset': {
      borderColor: 'primary.main'
    },

    '&.Mui-focused fieldset': {
      borderColor: 'primary.main',
      borderWidth: 1
    }
  },

  '& .MuiInputLabel-root': {
    color: '#B9B9B9'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: 'primary.main'
  }
};

const roundButtonSx = {
  lineHeight: '16px',
  mb: 0.5,
  mt: 2.5,
  px: '30px !important',
  py: '10px',
  width: 'auto'
};

const helperTextSx = {
  color: '#939393',
  fontSize: 10,
  mt: 1
};

const ForgotPw = () => {
  const [forgotPassword, setForgotPassword] = useState(true);
  const [sent, setSent] = useState(false);

  const showSent = () => {
    setForgotPassword(false);
    setSent(true);
  };

  return (
    <Slide
      direction="down"
      in
      timeout={300}
    >
      <Box>
        {forgotPassword && (
          <Box sx={cardSx}>
            <Box sx={headerSx}>
              <LockOpenOutlined />

              <Typography variant="h1">
                Forgot your password?
              </Typography>
            </Box>

            <Box sx={contentSx}>
              <Typography variant="h6">
                Please enter your username
              </Typography>

              <FormControl
                sx={fieldSx}
                variant="outlined"
              >
                <InputLabel htmlFor="username">
                  Username
                </InputLabel>

                <OutlinedInput
                  id="username"
                  label="Username"
                  name="uname"
                  type="text"
                />
              </FormControl>

              <Typography variant="h6">
                Please enter email associated with account
              </Typography>

              <FormControl
                sx={fieldSx}
                variant="outlined"
              >
                <InputLabel htmlFor="email">
                  Email
                </InputLabel>

                <OutlinedInput
                  id="email"
                  label="Email"
                  name="email"
                  type="email"
                />
              </FormControl>

              <br />

              <Fab
                aria-label="reset password"
                color="primary"
                onClick={showSent}
                size="medium"
                sx={roundButtonSx}
                variant="extended"
              >
                Reset Password
              </Fab>

              <Typography sx={helperTextSx}>
                Did you remember your password?{' '}

                <Link
                  component={RouterLink}
                  to="/sign-in"
                >
                  Try Logging in
                </Link>
              </Typography>
            </Box>
          </Box>
        )}

        {sent && (
          <Box sx={cardSx}>
            <Box sx={headerSx}>
              <LockOpenOutlined />

              <Typography variant="h1">
                Forgot your password?
              </Typography>
            </Box>

            <Box sx={contentSx}>
              <Typography>
                To ensure your security, a confirmation email has been sent to
                the registered email address.
                <br />
                Please check your mailbox and follow the instruction in the
                email.
              </Typography>

              <br />

              <Typography>
                Having problems?
                <br />
                If you do not receive your password recovery email within a
                few minutes, please check your spam folder.
              </Typography>

              <br />

              <Fab
                aria-label="go back"
                color="primary"
                component={RouterLink}
                size="medium"
                sx={roundButtonSx}
                to="/sign-in"
                variant="extended"
              >
                Go Back
              </Fab>

              <Typography sx={helperTextSx}>
                Did you remember your password?{' '}

                <Link
                  component={RouterLink}
                  to="/sign-in"
                >
                  Try Logging in
                </Link>
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Slide>
  );
};


export default ForgotPw;